export const testimonialsData = {
  fr: {
    label: "Témoignages",
    navLabel: "Témoignages",
    title: "Ils m'ont fait confiance.",
    ratingLabel: "2 avis sur PagesJaunes",
    items: [
      {
        quote: "Traducteur très professionnel, travaille rapidement et efficacement. Chaleureux et agréable à discuter, répond volontiers aux questions du client. Je suis très heureux de coopérer avec elle. Je la recommande vraiment.",
        name: "malceva.a.2020",
        meta: "Avis PagesJaunes · Novembre 2024",
      },
      {
        quote: "Très disponible et vraiment professionnelle.",
        name: "MarinaNikolaeva",
        meta: "Avis PagesJaunes · Octobre 2021",
      },
    ],
  },
  en: {
    label: "Testimonials",
    navLabel: "Testimonials",
    title: "They trusted me.",
    ratingLabel: "2 reviews on PagesJaunes",
    items: [
      {
        quote: "A very professional translator who works quickly and efficiently. Warm and pleasant to talk to, always happy to answer questions. I am very happy to work with her and truly recommend her.",
        name: "malceva.a.2020",
        meta: "PagesJaunes review · November 2024",
      },
      {
        quote: "Very available and truly professional.",
        name: "MarinaNikolaeva",
        meta: "PagesJaunes review · October 2021",
      },
    ],
  },
  ru: {
    label: "Отзывы",
    navLabel: "Отзывы",
    title: "Мне доверяют.",
    ratingLabel: "2 отзыва на PagesJaunes",
    items: [
      {
        quote: "Очень профессиональный переводчик: работает быстро и эффективно. Тёплое, приятное общение, с готовностью отвечает на вопросы клиента. Я очень довольна сотрудничеством и искренне рекомендую.",
        name: "malceva.a.2020",
        meta: "Отзыв PagesJaunes · ноябрь 2024",
      },
      {
        quote: "Всегда на связи и по-настоящему профессиональна.",
        name: "MarinaNikolaeva",
        meta: "Отзыв PagesJaunes · октябрь 2021",
      },
    ],
  },
  ua: {
    label: "Відгуки",
    navLabel: "Відгуки",
    title: "Мені довіряють.",
    ratingLabel: "2 відгуки на PagesJaunes",
    items: [
      {
        quote: "Дуже професійна перекладачка: працює швидко й ефективно. Тепле, приємне спілкування, з готовністю відповідає на запитання клієнта. Я дуже задоволена співпрацею та щиро рекомендую.",
        name: "malceva.a.2020",
        meta: "Відгук PagesJaunes · листопад 2024",
      },
      {
        quote: "Завжди на зв'язку і по-справжньому професійна.",
        name: "MarinaNikolaeva",
        meta: "Відгук PagesJaunes · жовтень 2021",
      },
    ],
  },
};
